import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ShowIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M8,0.4 C2.7512,0.4 0,4.2656 0,4.88 C0,5.4928 2.7512,9.36 8,9.36 C13.248,9.36 16,5.4928 16,4.88 C16,4.2656 13.248,0.4 8,0.4 Z M8,8.3256 C6.036,8.3256 4.444,6.7832 4.444,4.88 C4.444,2.9768 6.036,1.4328 8,1.4328 C9.964,1.4328 11.5552,2.9768 11.5552,4.88 C11.5552,6.7832 9.964,8.3256 8,8.3256 Z M8,4.88 C7.6744,4.5224 8.5304,3.1568 8,3.1568 C7.0176,3.1568 6.2216,3.9288 6.2216,4.88 C6.2216,5.8312 7.0176,6.6032 8,6.6032 C8.9816,6.6032 9.7784,5.8312 9.7784,4.88 C9.7784,4.4424 8.2768,5.1832 8,4.88 Z'/> ]
  getViewBox = () => '0 0 16 12'
}
